// RW 2026-08-28: GSAP global config, split out of an inline tag so it can run deferred
// AFTER vendor.min.js + animations.min.js (defer preserves document order).
gsap.defaults({ ease: Power4.easeOut });
gsap.config({ nullTargetWarn: false });
gsap.registerPlugin(ScrollTrigger);
